import styleCSS from "./chart-watermark.style.scss?inline"

export class ChartWatermarkComponent extends HTMLElement {
  private _watermarkDiv: HTMLDivElement;
  private _img: HTMLImageElement;
  private _observer: MutationObserver;

  constructor() {
    super();
    const shadowRoot = this.attachShadow({ mode: 'open' });
    
    // Add styles
    const style = document.createElement('style');
    style.textContent = styleCSS;
    shadowRoot.appendChild(style);

    // Create watermark elements
    this._watermarkDiv = document.createElement('div');
    this._watermarkDiv.id = 'watermark';

    this._img = document.createElement('img');
    this._watermarkDiv.appendChild(this._img);

    shadowRoot.appendChild(this._watermarkDiv);

    const logoUrl = this.getAttribute('data-logo-url') || 'https://cdn.prod.website-files.com/641b227fcd5cd9726f0781aa/64522458e65139808624c4cf_logo.svg';
    this._img.src = logoUrl;

    // Set up mutation observer
    this._observer = new MutationObserver(this.handleMutations.bind(this));
  }

  connectedCallback() {
    const logoUrl = this.getAttribute('data-logo-url');
    if (logoUrl) {
      this._img.src = logoUrl;
    }
    this._observer.observe(this, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this._observer.disconnect();
  }

  private handleMutations(_mutations: MutationRecord[]) {
    if (this.shadowRoot && !this.shadowRoot.contains(this._watermarkDiv)) {
      this.shadowRoot.appendChild(this._watermarkDiv);
    }
  }
}

customElements.define('tbw-chart-watermark', ChartWatermarkComponent); 